const ALPHABET = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];

export {
  ALPHABET,
}



// WEBPACK FOOTER //
// ./src/constants/index.js